import React, { FunctionComponent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { List, ListItemButton, ListItemText } from '@mui/material';

import { defaultServerUrls, setEnvironmentFromKey, setEnvironmentOverride } from '@paragon/environment-tools';
import { Dialog } from '@paragon/popup-state';
import { humanCase } from '@paragon/utilities';

import { useLibrarySelector } from '../hooks';

const NO_RELOAD_WARNING =
  "Changing the environment without reloading can lead to unexpected side effects because you will be using a user account and component design in an environment where they don't actually exist.  Are you sure you want to do this?";

const EnvironmentDevTools: FunctionComponent<{ onClose: () => void }> = (props) => {
  const dispatch = useDispatch();
  const activeEnvironment = useLibrarySelector((state) => state.environment.activeEnvironment);

  const [changedEnvironment, changeEnvironment] = useState<string | null>(null);

  return (
    <Dialog
      title="Choose active environment"
      onClose={props.onClose}
      submitText="Apply"
      onSubmit={() => {
        if (changedEnvironment !== null) {
          setEnvironmentOverride(changedEnvironment);
        } else {
          props.onClose();
        }
      }}
      otherButtons={{
        // the cancel button is defined here instead of using `onCancel` so the button order will remain correct
        cancel: { handler: props.onClose },

        'Apply without reloading': {
          handler: () => {
            if (window.confirm(NO_RELOAD_WARNING) && changedEnvironment !== null) {
              dispatch(setEnvironmentFromKey(changedEnvironment));
              props.onClose();
            }
          },
        },
      }}
    >
      <List>
        {Object.keys(defaultServerUrls).map((environmentKey) => (
          <ListItemButton
            key={environmentKey}
            selected={environmentKey === (changedEnvironment || activeEnvironment)}
            onClick={() => changeEnvironment(environmentKey)}
          >
            <ListItemText primary={humanCase(environmentKey)} />
          </ListItemButton>
        ))}
      </List>
    </Dialog>
  );
};

export default EnvironmentDevTools;
